import React from "react";
import { object, array, bool, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import Organism1 from "./Organism1";
import Organism3 from "./Organism3";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";

import { getSlug, getCollectionName } from "../../utils/utils";

import "./fiveStories1AdWithTagSearch.m.css";

const FiveStories1AdWithTagSearch = ({
  collection,
  sections,
  isSectionComponent = false,
  firstStoriesSet,
  widgetUrl = null,
  widgetHeight = null,
  domainSlug,
  pageType,
  lang,
}) => {
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const list = !firstStoriesSet ? collection.items.filter((item) => item.type === "story") : firstStoriesSet;
  const storyList = !firstStoriesSet ? list.slice(0, 6) : firstStoriesSet;
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const adSlotId = get(collection, ["associated-metadata", "ad_slot_id"], "default_ad_slot");

  if (!storyList.length) {
    return null;
  }
  return (
    <div styleName="base">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionName={collectionName} collectionSlug={collectionSlug} />
      )}
      <div styleName="wrapper">
        <div>
          <Organism1
            storyList={storyList.slice(0, 6)}
            langClass={pageType === "section-page" ? `${lang}-story-card` : ""}
          />
        </div>
        <Organism3
          className="organism-3"
          isSectionComponent={isSectionComponent}
          widgetUrl={widgetUrl}
          widgetHeight={widgetHeight}
          collectionSlug={collectionSlug}
          adSlotId={adSlotId}
          lang={lang}
        />
      </div>
    </div>
  );
};

FiveStories1AdWithTagSearch.propTypes = {
  collection: object,
  sections: array,
  isSectionComponent: bool,
  firstStoriesSet: array,
  widgetUrl: string,
  widgetHeight: string,
  domainSlug: string,
  pageType: string,
  lang: string,
};

FiveStories1AdWithTagSearch.storyLimit = 5;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  pageType: get(state, ["qt", "pageType"], ""),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(FiveStories1AdWithTagSearch);
